/**
 * A Composable for Search Animation
 * @returns object with `startSearchAnimation` function.
 */

export const useSearchAnimation = () => {
    // Mock translation function for the search pieces
    const _getTranslation = () =>
        (window.appContext.Brand.isSweepstake) ?
            "Spadegaming, Shady Lady, 18Peaches, Mortal Bromance, Rainbow Stacks, Dubai Luxury, Dragon Spins"
            : "Cleopatra, Immortal Romance, Pharaoh's Fortune, Playson, Microgaming, Book of Dead, Play'n Go";

    const _getPieces = () => {
        return _getTranslation()
            .split(",")
            .map((p) => p.trim());
    };

    // Composable data
    const data = {
        pieces: _getPieces(),
        container: null,
    };

    // Animation state
    const animation = {
        interval: null,
        speed: 75,
        wait: 1750,
        paused: false,
        animated: {
            text: data.pieces[0], // the full text to animate
            length: data.pieces[0].length, // length of text
            position: 0, // position of the substr of text.
            index: 0, // index of the text in the texts list.
            way: "forward", // the direction of the animation
        },
    };

    // Update the text into the container
    const _updateAnimatedText = () => {
        data.container.textContent = animation.animated.text.slice(
            0,
            animation.animated.position,
        );
    };

    // Function to play one animation iteration
    function _playAnimation() {
        if (animation.animated.way === "forward") {
            if (animation.animated.position < animation.animated.length) {
                // Move forward in the text
                animation.animated.position += 1;
                _updateAnimatedText();
            } else {
                animation.paused = true;
                setTimeout(() => {
                    animation.animated.way = "backward";
                    animation.animated.position = animation.animated.length - 1;
                    _updateAnimatedText();
                    animation.paused = false;
                }, animation.wait);
            }
        } else if (animation.animated.position > 0) {
            animation.animated.position -= 1;
            _updateAnimatedText();
        } else {
            animation.animated.way = "forward";
            animation.animated.position = 1;
            animation.animated.index =
                (animation.animated.index + 1) % data.pieces.length;
            animation.animated.text = data.pieces[animation.animated.index];
            animation.animated.length = animation.animated.text.length;
            _updateAnimatedText();
        }
    }

    // Public function to start the animation loop.
    const startSearchAnimation = (containerId) => {
        data.container = document.getElementById(containerId);
        animation.interval = setInterval(() => {
            if (!animation.paused) {
                _playAnimation();
            }
        }, animation.speed);
    };

    return { startSearchAnimation };
};
